export type AuthStatus = 'error' | 'success' | null;

export enum Lengths {
  PHONE = 11,
  CODE = 6,
}

export const RESEND_TIME = 30;
export const EMPTY_DIGITS = Array(Lengths.CODE).fill('');

export type CodeResponse = {
  success?: boolean;
  error?: string;
};

export enum AUTH_STATUS {
  ERROR = 'error',
  SUCCESS = 'success',
}
